export default function () {
  return [
    {
      title: 'Strona główna',
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: ''
    },
    {
      title: 'Zamówienia',
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">shopping_basket</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Produkty',
      to: '/produkty',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Procedury',
      to: '/procedury',
      htmlBefore: '<i class="material-icons">account_tree</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Użytkownicy',
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Klienci',
      to: '/klienci',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Stany materiałów',
      to: '/stany-materialow',
      htmlBefore: '<i class="material-icons">signal_cellular_alt</i>',
      htmlAfter: '',
      permission: 'is-admin',
      items: [
        {
          title: 'Produkty',
          to: '/stany-materialow/produkty'
        },
        {
          title: 'Materiały i kolory',
          to: '/stany-materialow/materialy-i-kolory'
        },
        {
          title: 'Historia zużycia',
          to: '/stany-materialow/historia-zuzycia'
        }
      ]
    },
    {
      title: 'Ustawienia',
      to: '/ustawienia',
      htmlBefore: '<i class="material-icons">settings_applications</i>',
      htmlAfter: '',
      permission: 'is-admin',
      items: [
        {
          title: 'Nici',
          to: '/ustawienia/nici'
        },
        {
          title: 'Materiały',
          to: '/ustawienia/materialy'
        },
        {
          title: 'Polary',
          to: '/ustawienia/polary'
        },
        {
          title: 'Przeszycia',
          to: '/ustawienia/przeszycia'
        },
        {
          title: 'Rozmiary',
          to: '/ustawienia/rozmiary'
        }
      ]
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj'
    }
  ];
}
